import React from 'react';

import { BaseMotionTokenTable, type MotionTokenTableValue } from '../base-table';

const values: MotionTokenTableValue[] = [
	{
		tokenName: 'motion.keyframe.scale.in.small',
		useFor: 'Modal or Spotlight entrance',
		value: '95-100%',
	},
	{
		tokenName: 'motion.keyframe.scale.out.small',
		useFor: 'Modal or Spotlight exit',
		value: '100-95%',
	},
];

/**
 * __Scale transition table__
 */
export const MotionScaleTransitionTable = (): React.JSX.Element => {
	return <BaseMotionTokenTable values={values} testId="motion-scale-table" />;
};
